<template>
  <section>
    <b-form-group
      label-size="lg"
      label-for="group_name"
      :label="$t('dharma-application-form.applicant.contact.principal.label.group-name')"
    >
      <b-form-input id="group_name" autocomplete="organization" v-model="applicant.group_name" trim></b-form-input>
      <b-form-text tag="p" text-variant="primary" class="font-weight-bold" v-if="delivery.object === 'principal'">
        {{ $t('dharma-application-form.applicant.contact.help-text.group-name.fill-in-chinese-or-english') }}
      </b-form-text>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="name"
      :label="$t('dharma-application-form.applicant.contact.principal.label.name')"
    >
      <b-form-input id="name" autocomplete="name" v-model="applicant.name" trim></b-form-input>
      <b-form-text tag="p" text-variant="primary" class="font-weight-bold" v-if="delivery.object === 'principal'">
        <!-- 所填寫的姓名將作為收件人姓名，請確認其正確無誤。<br> -->
        {{ $t('dharma-application-form.applicant.contact.help-text.name.fill-in-chinese-or-english') }}
      </b-form-text>
      <b-form-text tag="p" text-variant="warning" class="font-weight-bold" v-if="delivery.area === 'China Mainland'">
        {{ $t('dharma-application-form.applicant.contact.help-text.name.fill-in-the-real-name') }}
      </b-form-text>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="email"
      :label="$t('dharma-application-form.applicant.contact.principal.label.email')"
    >
      <b-form-input id="email" autocomplete="email" v-model="applicant.email" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="phone"
      :label="$t('dharma-application-form.applicant.contact.principal.label.phone')"
    >
      <b-form-input id="phone" autocomplete="tel" v-model="applicant.phone" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="mobile_phone"
      :label="$t('dharma-application-form.applicant.contact.principal.label.mobile-phone')"
    >
      <b-form-input id="mobile_phone" autocomplete="tel" v-model="applicant.mobile_phone" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="fax"
      :label="$t('dharma-application-form.applicant.contact.principal.label.fax')"
      v-if="delivery.object === 'principal' && is_bulk_application"
    >
      <b-form-input id="fax" v-model="applicant.fax" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="official_email"
      :label="$t('dharma-application-form.applicant.contact.principal.label.official-email')"
      v-if="delivery.object === 'principal' && is_bulk_application && delivery.area === 'India'"
    >
      <b-form-input id="official_email" v-model="applicant.official_email" trim></b-form-input>
    </b-form-group>
    <b-form-row v-if="delivery.object === 'principal' && ((is_bulk_application && ['Brazil', 'India', 'Bhutan', 'Nepal', 'Indonesia'].includes(delivery.area)) || (!is_bulk_application && delivery.area === 'Brazil'))">
      <b-col>
        <van-divider
          :style="{ color: '#ed6a0c', borderColor: '#ed6a0c', 'font-size': '1.5em' }"
        >{{ $t('dharma-application-form.applicant.tax.title') }}</van-divider>
      </b-col>
    </b-form-row>
    <b-form-group
      label-size="lg"
      label-for="tin"
      :label="$t('dharma-application-form.applicant.tax.label.tin')"
      v-if="delivery.object === 'principal' && ((is_bulk_application && ['Brazil', 'India', 'Bhutan', 'Nepal', 'Indonesia'].includes(delivery.area)) || (!is_bulk_application && delivery.area === 'Brazil'))"
    >
      <b-form-input id="tin" v-model="applicant.tin" trim></b-form-input>
      <b-form-text
        tag="p"
        text-variant="danger"
        class="font-weight-bold"
        v-html="$t(`dharma-application-form.applicant.contact.help-text.tin.need-to-fill-in-${is_bulk_application ? 'for-large-quantity-applications' : 'for-small-quantity-applications'}`)"
      ></b-form-text>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="iec"
      :label="$t('dharma-application-form.applicant.tax.label.iec')"
      v-if="delivery.object === 'principal' && is_bulk_application && delivery.area === 'India'"
    >
      <b-form-input id="iec" v-model="applicant.iec" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="pan"
      :label="$t('dharma-application-form.applicant.tax.label.pan')"
      v-if="delivery.object === 'principal' && is_bulk_application && delivery.area === 'India'"
    >
      <b-form-input id="pan" v-model="applicant.pan" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="gstin"
      :label="$t('dharma-application-form.applicant.tax.label.gstin')"
      v-if="delivery.object === 'principal' && is_bulk_application && delivery.area === 'India'"
    >
      <b-form-input id="gstin" v-model="applicant.gstin" trim></b-form-input>
    </b-form-group>
    <b-form-row v-if="delivery.area === 'China Mainland'">
      <b-col class="text-primary">
        <p class="font-weight-bold">{{ $t('dharma-application-form.applicant.contact.help-text.strictly-prohibited-for-sale') }}</p>
      </b-col>
    </b-form-row>
    <b-form-row v-if="Object.keys(validation_results.applicant).length > 0">
      <b-col class="text-danger">
        <p
          class="font-weight-bold"
          v-for="field in validation_results.applicant.fieldErrors"
        >{{ field.message }}</p>
      </b-col>
    </b-form-row>
  </section>
</template>

<script>
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

import { Divider } from 'vant'
import { FormGroupPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { Validators, createFormValidation } from '@lemoncode/fonk'
import { requiredByField } from '@lemoncode/fonk-required-by-field-validator'

import ContainsNoChineseCharactersValidator from '@/services/fonk-validation-service/contains-no-chinese-characters-validator'

Vue.use(Divider)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(VueLocalStorage)

export default {
  name: 'principal-form',
  props: {
    delivery: {
      type: Object
    },
    form_data: {
      type: Object,
      default: () => ({})
    },
    is_bulk_application: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      applicant: {
        group_name: '',
        name: '',
        email: '',
        phone: '',
        mobile_phone: '',
        fax: '',
        official_email: '',
        iec: '',
        gstin: '',
        pan: '',
        tin: '',
        type: 'principal'
      },
      validation_results: {
        applicant: {}
      }
    }
  },
  watch: {
    form_data: {
      handler(new_value) {
        if (new_value) {
          this.applicant = { ...this.applicant, ...new_value };
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    validation_schema() {
      return {
        field: {
          group_name: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.contact.principal.error-message.group-name.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.contact.principal.error-message.group-name.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => (this.delivery.object && this.delivery.object === 'principal') && (this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1)
              }
            }
          ],
          name: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.contact.principal.error-message.name.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.contact.principal.error-message.name.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => (this.delivery.object && this.delivery.object === 'principal') && (this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1)
              }
            }
          ],
          email: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.contact.principal.error-message.email.required')
            },
            {
              validator: Validators.email,
              message: this.$t('dharma-application-form.applicant.contact.principal.error-message.email.invalid')
            }
          ],
          phone: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.contact.principal.error-message.phone.required')
          }],
          mobile_phone: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.contact.principal.error-message.mobile-phone.required')
          }],
          official_email: [{
            validator: Validators.email,
            message: this.$t('dharma-application-form.applicant.contact.principal.error-message.official-email.invalid')
          }],
          tin: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.tax.error-message.tin.required')
          }],
          iec: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.tax.error-message.iec.required')
          }],
          pan: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'gstin',
              condition: (value) => !value
            },
            message: this.$t('dharma-application-form.applicant.tax.error-message.pan.required')
          }],
          gstin: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'pan',
              condition: (value) => !value
            },
            message: this.$t('dharma-application-form.applicant.tax.error-message.gstin.required')
          }]
        }
      }
    }
  },
  methods: {
    async validateForm() {
      await this.validateApplicant()
      return this.validation_results.applicant.succeeded
    },
    async validateApplicant() {
      let field_name = ['group_name', 'name', 'email', 'phone', 'mobile_phone']
      if (this.is_bulk_application) {
        if (this.delivery.area === 'India') {
          field_name = field_name.concat(['official_email'])
        }
      } else {
        if (this.delivery.area === 'Brazil') {
          field_name = field_name.concat(['tin'])
        }
      }

      const validation_schema = this.getValidationSchemaByFieldName(field_name);
      const validation = createFormValidation(validation_schema);
      await validation
        .validateForm(this.applicant)
        .then(form_validation_result => {
          this.validation_results.applicant = form_validation_result;
        });
    },
    getValidationSchemaByFieldName(field_name) {
      const field_validation_schema = field_name.reduce((field_validation_schema, key) => {
        if (this.validation_schema.field.hasOwnProperty(key)) {
          field_validation_schema[key] = this.validation_schema.field[key];
        }
        return field_validation_schema;
      }, {});

      return { field: field_validation_schema }
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }  
}
</script>